import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, $dmSansFontFamily } from '@similarweb/styles';

import { Button } from '../../Button';
import { IconButton } from '../../Button/IconButton';

export const StyledCreditsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 4px;
`;

export const StyledCredits = styled.span`
  margin: 0 2px 0 0;
  color: ${colorsPalettes.carbon[300]};
  font-family: ${$dmSansFontFamily};
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
`;

export const StyledCreditsValue = styled.span`
  color: ${colorsPalettes.carbon[400]};
  font-family: ${$dmSansFontFamily};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

export const StyledCreditsButton = styled(Button)`
  padding: 4px;
  border-radius: 4px;
  line-height: 16px;
`;

export const StyledUpgradeIconButton = styled(IconButton)`
  padding: 2px 12px;
  font-size: 12px;

  ${SWReactIcons} {
    display: flex;
  }
`;
